<template>
  <div class="flex items-baseline">
    <a :href="href" class="pr-4 md:pr-0 text-center">
      <span class="relative inline-block mb-4">
        <i class="far fa-heart lg:mr-12 text-2xl"></i>
        <span
          id="favoriteCount"
          class="absolute -top-6 -right-6 lg:right-0 rounded-full bg-orange font-bold text-white text-center text-12 block w-16 lg:w-5 h-16 lg:h-5 leading-4 lg:leading-5"
        >
          {{ counter }}
        </span>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "TheFavoriteLink",

  props: ["href"],

  data() {
    return {
      counter: 0,
    };
  },

  created() {
    window.TheFavoriteLink = this;
    axios
      .get("/web/api/search/artworks/favorites/count")
      .then(({ data: data }) => {
        this.counter = data.count;
      });
  },

  methods: {
    increment() {
      this.counter++;
    },

    decrement() {
      this.counter--;
    },
  },
};
</script>
